import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const BusquedaBitacoraBIM = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Bitacora/BusquedaBitacoraBIM",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { BusquedaBitacoraBIM };